import Locale from "../locales";

export const piecesStatuses = ["idle", "ongoing", "completed", "inCompleted"];

export const pieceStatusText = {
  idle: Locale.t("idle"),
  ongoing: Locale.t("ongoing"),
  completed: Locale.t("completed"),
  inCompleted: Locale.t("inCompleted"),
};
